import { createRoot } from "react-dom/client";
import MainApp from "./MainApp";

const rootEl = document.getElementById("app-site");
const root = createRoot(rootEl);

root.render(<MainApp />);
